var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6 13.1L25.5 9.4c-.2-.1-.4-.1-.6 0l-7.5 2.8c.3-.8.4-1.4.4-2C17.8 6.8 15 4 11.6 4 8.4 4 5.7 6.4 5.4 9.5h-.2c-.5-.2-1.2.2-1.2.8v21.2c0 .3.2.7.5.8L14.6 36c.2.1.4.1.6 0l9.8-3.6 9.8 3.6c.3.1.7.1.8-.1.2-.2.4-.5.4-.7V13.9c.2-.4-.1-.8-.4-.8zM14.2 33.8l-8.3-3V12.3c1.2 3.5 4.6 8.2 5 8.8.4.5 1.1.5 1.5 0 .2-.3 1-1.4 1.8-2.9v15.6zM7.1 10.1c0-2.5 2-4.4 4.4-4.4s4.4 2 4.4 4.4c0 1.7-2.5 6-4.4 8.9-1.9-2.8-4.4-7.2-4.4-8.9zm8.8 5.2c.2-.3.3-.5.5-.9l7.9-2.9v19.3L16 33.9V15.3zm18.5 18.5l-8.3-3.1v-8.1h1.7c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-1.7V19h3.5c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-3.5v-5.8l8.3 3.1v19.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1 8.4h-1c-.5 0-.9.4-.9.9s.4.9.9.9h1c.5 0 .9-.4.9-.9-.1-.5-.5-.9-.9-.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMap);
export default __webpack_public_path__ + "static/media/location-map.1590dc5c.svg";
export { ForwardRef as ReactComponent };